// MSPs Data - Managed Service Providers

export const mspsHeroData = {
  tagline: "MANAGED SERVICE PROVIDERS",
  title: "Escala tu negocio MSP con automatización inteligente",
  subtitle: "Plataforma todo-en-uno para MSPs que quieren gestionar múltiples clientes, servicios cloud y facturación recurrente desde un único panel de control.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const mspsStatsData = [
  { number: "85%", label: "Reducción tareas manuales" },
  { number: "3x", label: "Más clientes gestionados" },
  { number: "40%", label: "Aumento en márgenes" },
  { number: "24/7", label: "Monitoreo automatizado" }
];

export const clientManagementData = [
  {
    id: 1,
    title: "Portal multi-cliente centralizado",
    description: "Gestiona todos tus clientes desde un único dashboard con segregación de datos y permisos granulares.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Onboarding automatizado",
    description: "Configura nuevos clientes en minutos con templates predefinidos y aprovisionamiento automático.",
    icon: "UserPlus"
  },
  {
    id: 3,
    title: "Gestión de tickets integrada",
    description: "Centraliza soporte, incidencias y SLAs por cliente con escalamiento automático.",
    icon: "Ticket"
  },
  {
    id: 4,
    title: "Reportes por cliente",
    description: "Genera informes automatizados de uso, rendimiento y facturación para cada cliente.",
    icon: "FileText"
  }
];

export const serviceStackData = [
  {
    id: 1,
    title: "Microsoft 365 & Azure",
    description: "Aprovisionamiento, gestión de licencias y facturación automatizada de productos Microsoft.",
    icon: "Cloud",
    vendors: ["Microsoft 365", "Azure", "Dynamics 365"]
  },
  {
    id: 2,
    title: "Seguridad Gestionada",
    description: "Integra soluciones de backup, antivirus y seguridad perimetral en tu stack de servicios.",
    icon: "Shield",
    vendors: ["Acronis", "Bitdefender", "SentinelOne"]
  },
  {
    id: 3,
    title: "Infraestructura Cloud",
    description: "Gestiona recursos AWS, Google Cloud y hosting desde una única plataforma.",
    icon: "Server",
    vendors: ["AWS", "Google Cloud", "DigitalOcean"]
  },
  {
    id: 4,
    title: "Comunicaciones Unificadas",
    description: "VoIP, videoconferencia y colaboración integrados con tu oferta de servicios.",
    icon: "Phone",
    vendors: ["Teams", "Zoom", "RingCentral"]
  }
];

export const automationFeaturesData = [
  {
    id: 1,
    title: "RMM Integrado",
    description: "Conecta con tus herramientas RMM favoritas para automatizar alertas, parches y mantenimiento.",
    icon: "Monitor"
  },
  {
    id: 2,
    title: "PSA Sincronizado",
    description: "Integración bidireccional con ConnectWise, Autotask y otros PSA para flujos sin fricciones.",
    icon: "RefreshCw"
  },
  {
    id: 3,
    title: "Facturación recurrente",
    description: "Automatiza cobros mensuales con reconciliación de uso y facturación consolidada.",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "Workflows personalizados",
    description: "Crea automatizaciones a medida para onboarding, renovaciones y escalamientos.",
    icon: "GitBranch"
  }
];

export const pricingModelsData = [
  {
    id: 1,
    title: "Per-User Pricing",
    description: "Cobra por usuario con licencias flexibles que escalan con el cliente.",
    icon: "User"
  },
  {
    id: 2,
    title: "Bundles de Servicios",
    description: "Crea paquetes de servicios combinados con precios atractivos.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Pricing Tiered",
    description: "Ofrece niveles de servicio (Bronze, Silver, Gold) con características diferenciadas.",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Consumo Variable",
    description: "Factura por uso real en servicios de infraestructura y almacenamiento.",
    icon: "BarChart2"
  }
];

export const growthToolsData = [
  {
    id: 1,
    title: "Marketplace White-Label",
    description: "Tu propia tienda de servicios cloud con tu marca para venta directa a clientes."
  },
  {
    id: 2,
    title: "Cotizaciones Instantáneas",
    description: "Genera propuestas profesionales en segundos con precios actualizados en tiempo real."
  },
  {
    id: 3,
    title: "Cross-sell Inteligente",
    description: "Recomendaciones automáticas de productos complementarios basadas en el perfil del cliente."
  },
  {
    id: 4,
    title: "Pipeline de Ventas",
    description: "Seguimiento de oportunidades desde lead hasta cierre con métricas de conversión."
  }
];

export const mspsFAQData = [
  {
    question: "¿Cómo ayuda la plataforma a escalar mi MSP?",
    answer: "Automatizamos las tareas operativas repetitivas (provisioning, facturación, reportes) para que puedas gestionar 3x más clientes sin aumentar tu equipo. El tiempo liberado te permite enfocarte en servicios de mayor valor y crecimiento estratégico."
  },
  {
    question: "¿Qué integraciones están disponibles?",
    answer: "Ofrecemos integraciones nativas con los principales vendors (Microsoft, AWS, Google), herramientas RMM (Datto, NinjaRMM), PSAs (ConnectWise, Autotask) y soluciones de seguridad (Acronis, Bitdefender). También tenemos APIs abiertas para integraciones personalizadas."
  },
  {
    question: "¿Puedo personalizar los precios por cliente?",
    answer: "Sí, soportamos múltiples modelos de pricing: per-user, bundles, tiered y consumo variable. Puedes definir márgenes personalizados por cliente, descuentos por volumen y promociones temporales."
  },
  {
    question: "¿Cómo funciona la facturación multi-cliente?",
    answer: "La plataforma consolida el uso de todos los servicios por cliente, aplica los precios acordados y genera facturas automáticas. Puedes configurar ciclos de facturación diferentes por cliente y métodos de pago variados."
  },
  {
    question: "¿Qué nivel de soporte ofrecen?",
    answer: "Todos los MSPs tienen acceso a soporte técnico 24/7, un Customer Success Manager dedicado, documentación completa y una comunidad activa de partners. También ofrecemos onboarding guiado y capacitación continua."
  }
];

export const mspTestimonialData = {
  quote: "Desde que implementamos esta plataforma, hemos duplicado nuestra base de clientes sin aumentar el equipo de operaciones. La automatización de facturación y provisioning nos ahorra más de 40 horas semanales.",
  author: "Laura Méndez",
  role: "CEO",
  company: "CloudTech Solutions MSP",
  location: "MSP, Madrid"
};
